module.exports = __webpack_public_path__ + "img/new-logo-black.80bf7f9f.png";